<template>
  <!-- 260626 비즈 상세 헤더 '공유' 버튼 → 카톡/문자/인스타/페북 하단 시트.
       (남의 업체 한정. 내 업체는 본문 4그리드 유지) 내부 .modal 영역 밖(딤) 탭 시 index.vue modalOutSideEvent로 닫힘. -->
  <div class="modal-dim on">
    <div class="share-sheet-wrap">
      <div class="share-sheet modal">
        <div class="share-sheet__handle" aria-hidden="true"></div>
        <p class="share-sheet__title">공유하기</p>
        <div class="share-sheet__grid">
          <button type="button" class="share-sheet__tile" @click="onShare('kakao')">
            <img class="share-sheet__img" :src="icoKakao" alt="" />
            <span>카카오톡</span>
          </button>
          <button type="button" class="share-sheet__tile" @click="onShare('sms')">
            <img class="share-sheet__img" :src="icoSms" alt="" />
            <span>문자</span>
          </button>
          <button type="button" class="share-sheet__tile" @click="onComingSoon('인스타그램')">
            <img class="share-sheet__img" :src="icoInstagram" alt="" />
            <span>인스타그램</span>
          </button>
          <button type="button" class="share-sheet__tile" @click="onComingSoon('페이스북')">
            <img class="share-sheet__img" :src="icoFacebook" alt="" />
            <span>페이스북</span>
          </button>
        </div>
        <button type="button" class="share-sheet__close" @click="close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { showTextModal } from '@/common/utils/ModalState';
import { shareBusinessChannel } from '@/common/service/share/businessShare';
// 대표 제공 아이콘 (detail.vue 본문 4그리드와 동일 에셋)
import icoKakao from '@/assets/static/images/renewal/contact/kakao.png';
import icoSms from '@/assets/static/images/renewal/contact/sms.png';
import icoInstagram from '@/assets/static/images/renewal/contact/instagram.png';
import icoFacebook from '@/assets/static/images/renewal/contact/facebook.png';

defineProps(['data']);
const emits = defineEmits(['close']);

// 200ms = dim 페이드 아웃 대기(하우스 모달 패턴: alert.vue / NaviSelectModal.vue 동일).
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};

const onShare = method => {
  shareBusinessChannel(method);
  close();
};

const onComingSoon = channel => {
  showTextModal(`${channel} 공유는 준비 중입니다.`, '확인');
};
</script>

<style scoped>
.share-sheet-wrap {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1;
}
/* 전역 .modal(중앙 카드) 폭/곡률 오버라이드 → 풀폭 하단 시트 */
.share-sheet.modal {
  min-width: 0;
  max-width: 60rem;
  width: 100%;
  max-height: 80%;
  padding: 0.8rem 1.6rem calc(2.4rem + env(safe-area-inset-bottom));
  border-radius: 1.6rem 1.6rem 0 0;
  animation: sheetUp 0.25s ease;
}
@keyframes sheetUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
.share-sheet__handle {
  width: 4rem;
  height: 0.4rem;
  margin: 0 auto 1.2rem;
  border-radius: 0.2rem;
  background: #e0e0e0;
}
.share-sheet__title {
  margin: 0 0 1.6rem;
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
}
.share-sheet__grid {
  display: flex;
  justify-content: space-around;
  gap: 1rem;
}
.share-sheet__tile {
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #000;
  opacity: 0.85;
}
.share-sheet__img {
  width: 4.4rem;
  height: 4.4rem;
  object-fit: contain;
}
.share-sheet__close {
  width: 100%;
  margin-top: 2rem;
  padding: 1.3rem;
  border: none;
  border-radius: 1rem;
  background: #f2f2f2;
  font-size: 1.5rem;
  font-weight: 700;
  color: #555;
  cursor: pointer;
}
</style>
